import React, { useCallback, useState } from 'react';

import { formatRosterDate, getTodayDeviceRosterDate } from '../../../../common/utils/people/roster';
import { Sheet } from '../../../design/components';
import { ROSTER_DATE_FORMAT } from '../rosterHelpers';
import MonthCalendar, { getMonthStart } from './MonthCalendar';
import SelectField from './SelectField';

/**
 * DateSelect: SelectField that opens a month calendar in a sheet; picking a day closes it.
 * Props: label, value (YYYY-MM-DD or ''), onChange(date), minimumDate, disabled, style
 */
const DateSelect = ({
	label,
	value,
	onChange,
	minimumDate,
	disabled,
	style,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const [month, setMonth] = useState(null);

	// Open on the chosen date's month, else the earliest allowed month, else this month.
	const open = useCallback(() => {
		setMonth(getMonthStart(value || minimumDate || getTodayDeviceRosterDate()));
		setIsOpen(true);
	}, [minimumDate, value]);
	const close = useCallback(() => setIsOpen(false), []);
	const select = useCallback((date) => {
		onChange(date);
		setIsOpen(false);
	}, [onChange]);

	return (
		<>
			<SelectField
				label={label}
				valueLabel={value ? formatRosterDate(value, ROSTER_DATE_FORMAT) : ''}
				placeholder="Select date"
				onPress={open}
				disabled={disabled}
				style={style}
			/>
			<Sheet isVisible={isOpen} onClose={close} title={label}>
				{Boolean(month) && (
					<MonthCalendar
						month={month}
						onChangeMonth={setMonth}
						selectedDate={value}
						onSelectDate={select}
						today={getTodayDeviceRosterDate()}
						minimumDate={minimumDate}
					/>
				)}
			</Sheet>
		</>
	);
};

export default DateSelect;
